import { DELETE_COURSES_LOADING, DELETE_COURSES_SUCCESS, DELETE_COURSES_ERROR } from "../../../constant/actionTypes";

const deleteCourseReducer = (state = {}, action) => {
    switch (action.type) {
        case DELETE_COURSES_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case DELETE_COURSES_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        case DELETE_COURSES_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default deleteCourseReducer;